module.exports = __webpack_public_path__ + "static/img/g1.d28f919.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/g1.png
// module id = yA2K
// module chunks = 0